// @flow

const styles = {
  processLegend: (theme) => ({
    textAlign: 'center'
  }),
  dialogContentCtr: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    position: 'relative'
  }),
  arrowIcon: (theme) => ({
    position: 'relative',
    fontSize: 52,
    opacity: '25%'
  }),
  textField: (theme) => ({
    '& label.MuiInputLabel-shrink': {
      transform: 'translate(24px, -5px) scale(0.75)'
    }
  }),
  textFieldCaptionRight: (theme) => ({
    textAlign: 'right',
    color: theme.palette.primary.light,
    fontSize: '0.8rem'
  }),
  iconButton: (theme) => ({
    float: 'left'
  }),
  errorLabel: (theme) => ({
    marginLeft: theme.spacing(1),
    color: '#f44336 !important'
  }),
  tagCtr: (theme) => ({
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(4)
  }),
  colorPickerRainbow: (theme) => ({
    background: 'conic-gradient(red, yellow, lime, aqua, blue, magenta, red)',
    width: theme.spacing(3),
    height: theme.spacing(3),
    borderRadius: theme.spacing(3),
    cursor: 'pointer',
    position: 'relative',
    top: 6
  }),
  popperCtr: (theme) => ({
    zIndex: 9999,
    top: '12px !important',
    left: '116px !important',
    [theme.breakpoints.down('sm')]: {
      left: '32px !important'
    }
  }),
  margin: (theme) => ({
    marginTop: theme.spacing(3)
  }),
  grow: (theme) => ({
    flexGrow: 1
  }),
  flexContainer: (theme) => ({
    display: 'flex',
    flexDirection: 'column'
  })
};
  
export default styles;